<template>
  <div v-if="$route.params.id" class="form-wrap">
    <div class="card form-card">
      <h5 class="card-header  bg-info-900 font-weight-bold">Inscripción - Datos Basicos del estudiante</h5>
      <div class="card-body">
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group">
                <label>Tipo Documento</label>
                <select class="custom-select custom-select-sm" v-model="id_tipo_doc" :class="{'is-invalid': $v.id_tipo_doc.$error}">
                  <option value="">Seleccione ...</option>
                  <option value="3">No. UNICO DE IDENTIFICACION</option>
                  <option value="4">Registro civil</option>
                  <option value="5">Tarjeta de identidad</option>
                  <option value="8">Número Establecido por Secretaria</option>
                  <option value="9">Número Identifiación Personal</option>
                </select>
                <div class="invalid-feedback" v-if="$v.id_tipo_doc.$dirty && !$v.id_tipo_doc.required">Tipo de documento es
                  obligatorio
                </div>
              </div>
              <div class="form-group input-group-sm">
                <label>Numero de documento</label>
                <input type="text" class="form-control" maxlength="15" v-model="num_doc" :class="{'is-invalid': $v.num_doc.$error}">
                <div class="invalid-feedback" v-if="$v.num_doc.$dirty && !$v.num_doc.required">Numero de documento es
                  obligatorio
                </div>
              </div>
              <div class="form-group input-group-sm">
                <label>Nombres</label>
                <input type="text" class="form-control" maxlength="30" v-model="nom" :class="{'is-invalid': $v.nom.$error}">
                <div class="invalid-feedback" v-if="$v.nom.$dirty && !$v.nom.required">Nombres es obligatorio</div>
              </div>
              <div class="form-group input-group-sm">
                <label>Apellidos</label>
                <input type="text" class="form-control" maxlength="30" v-model="apell" :class="{'is-invalid': $v.apell.$error}">
                <div class="invalid-feedback" v-if="$v.apell.$dirty && !$v.apell.required">Apellidos es obligatorio</div>
              </div>
              <div class="form-group input-group-sm">
                <label>Fecha Nacimiento</label>
                <input type="date" class="form-control" v-model="fecha_nac" :class="{'is-invalid': $v.fecha_nac.$error}">
                <div class="invalid-feedback" v-if="$v.fecha_nac.$dirty && !$v.fecha_nac.required">Fecha de nacimiento es obligatoria</div>
              </div>
              <div class="form-group">
                <label>Sexo</label>
                <select class="custom-select custom-select-sm" v-model="sexo" :class="{'is-invalid': $v.sexo.$error}">
                  <option value="">Seleccione ...</option>
                  <option value="M">Masculino</option>
                  <option value="F">Femenino</option>
                </select>
                <div class="invalid-feedback" v-if="$v.sexo.$dirty && !$v.sexo.required">Sexo es obligatorio</div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group input-group-sm">
                <label>Correo</label>
                <input type="email" class="form-control" placeholder="ingrese correo" maxlength="70" v-model="correo" :class="{'is-invalid': $v.correo.$error}">
                <div class="invalid-feedback" v-if="$v.correo.$dirty && !$v.correo.required">Correo es obligatorio</div>
              </div>
              <div class="form-group input-group-sm">
                <label>Numero de contacto</label>
                <input class="form-control" maxlength="20" v-model="contacto" :class="{'is-invalid': $v.contacto.$error}">
                <div class="invalid-feedback" v-if="$v.contacto.$dirty && !$v.contacto.required">Apellidos es obligatorio</div>
              </div>
              <div class="form-group">
                <label>Curso al que aspira</label>
                <select v-model="id_cupo" class="custom-select custom-select-sm" :class="{'is-invalid': $v.id_cupo.$error}">
                  <option value="">Seleccione ...</option>
                  <option v-for="cupo in cupos" :value="cupo.id" :key="cupo.id">{{cupo.nom_curso}}</option>
                </select>
                <div class="invalid-feedback" v-if="$v.id_cupo.$dirty && !$v.id_cupo.required">Curso al que aspira es obligatorio</div>
              </div>
              <div class="form-group input-group-sm">
                <label>Referencia de pago</label>
                <input v-model="referen" class="form-control" maxlength="40">
              </div>
              <div class="form-group">
                <label>Subir comprobante de pago</label>
                <uploader :end-point="url_upload+$route.params.id"
                          :multipart="true"
                          :showProgressBar="true"
                          @fileUploaded="uploaded"
                          @startUpload="reset">
                  <span slot="browse-btn" class="btn btn-success">Selecccionar archivo</span>
                </uploader>
                <div v-if="id_upload" class="alert alert-info text-center bg-success text-white font-weight-bold">Comprobante cargado <span>&#128077;</span></div>
                <div class="text-danger" style="font-size: small" v-if="$v.id_upload.$dirty && !$v.id_upload.required">Comprobante de pago es obligatorio</div>
              </div>
            </div>
          </div>
          <button @click="save" class="btn btn-info float-right"><i class="fal fa-paper-plane"></i> Enviar</button>
      </div>
    </div>
  </div>
  <div v-else class="form-wrap">
    <div class="alert alert-info bg-info-900 text-center">NO HEMOS PODIDO IDENTIFICAR LA INSTITUCIÓN DONDE USTED DESEA REALIZAR LA INSCRIPCIÓN</div>
  </div>
</template>
<script>
import axios from "axios";
import {required} from 'vuelidate/lib/validators'
import uploader from 'vuejs-uploader'
import Swal from 'sweetalert2'
export default {
  name: "inscripcion",
  components:{uploader},
  data(){
    return {
      id_tipo_doc:'',
      num_doc:'',
      nom:'',
      apell:'',
      fecha_nac:'',
      sexo:'',
      correo:'',
      contacto:'',
      referen:'',
      id_upload:'',
      id_cupo:'',
      cupos:[],
      url_upload:''
    }
  },
  validations:{
    id_tipo_doc:{required},
    num_doc:{required},
    nom:{required},
    apell:{required},
    fecha_nac:{required},
    sexo:{required},
    correo:{required},
    contacto:{required},
    id_upload:{required},
    id_cupo:{required},
  },
  mounted() {
    this.url_upload = process.env.VUE_APP_API_ENDPOINT_UPLOAD;
    console.log(process.env)
  },
  methods:{
    listCupos(id){
      axios.post(process.env.VUE_APP_API_ENDPOINT,{flag:'listCupos',c:id}).then(resp=>{
        this.cupos = resp.data;
      }).catch(err => {
        if(err instanceof Error) {
          console.log(err.message);
        } else {
          console.log(err.data);
        }
      });
    },
    save(){
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      let data = Object.assign({}, this.$data);
      data.flag = 'save';
      data.c = this.$route.params.id;
      Swal.fire('Enviando Inscripción','conectando ...','info')
      Swal.showLoading();
      axios.post(process.env.VUE_APP_API_ENDPOINT, data).then(resp => {
        if (resp.data.estado === 'success') {
          Swal.fire({
            title: 'Inscripción registrada!',
            text: "Codigo de registro: "+resp.data.id,
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Terminar inscripción!'
          }).then(() => {
            window.location.href = "https://lms.edutracer.com";
          })
        }
      })
    },
    uploaded(data){
      this.id_upload = data.response.id;
    },
    reset(){
      this.id_upload = '';
    }
  },
  watch:{
    $route(data){
      this.listCupos(data.params.id);
    }
  }
}
</script>

<style scoped>
.form-wrap {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}
.form-card label {
  font-weight: bold;
}
.form-card {
  width: 100%;
  max-width: 600px;
}
</style>
